@if (!(isLoading$ | async)) {
  <div class="login-register-content">
    <div class="row justify-content-center">
      <form (ngSubmit)="submitForm()" [formGroup]="registerForm" class="w-100">
        @if (!showProfessionalForm || (!validateTaxIdentification && showProfessionalForm)) {
          <div class="form-group radio-inline d-flex radio-buttons-form"
            >
            <span class="form-check">
              <label class="checkbox">
                <input
                  id="dos"
                  class="form-check-input"
                  role="radio"
                  type="radio"
                  (change)="professional(false);removeValidators(registerForm);initForm()"
                  [value]="false"
                  formControlName="professional"
                  />
                {{ 'loginForm.particular' | cxTranslate }}
              </label>
            </span>
            <span class="form-check">
              <label class="checkbox">
                <input
                  class="form-check-input"
                  id="uno"
                  role="radio"
                  type="radio"
                  (change)="professional(true);updateForm()"
                  [value]="true"
                  aria-checked="true"
                  formControlName="professional"
                  />
                {{ 'loginForm.professional' | cxTranslate }}
              </label>
            </span>
          </div>
        }
        <div class="row professional-form">
          @if (!validateTaxIdentification || !showProfessionalForm) {
            <div [class]="showProfessionalForm ? 'col-md-6 input-field' : 'col-md-12 input-field'">
              @if (showProfessionalForm) {
                <div class="title-register">
                  {{ 'register.privateInfo' | cxTranslate }}
                </div>
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.contactPerson.label' | cxTranslate }}
                    </span>
                    <input
                      class="form-control"
                      type="text"
                      name="contactPerson"
                      formControlName="contactPerson"
                      maxlength="35"
                      />
                    <cx-form-errors [control]="registerForm.get('contactPerson')"></cx-form-errors>
                  </label>
                </div>
              } @else {
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.contactPerson.label' | cxTranslate}}
                    </span>
                    <input
                      class="form-control"
                      type="text"
                      name="firstName"
                      formControlName="firstName"
                      maxlength="35"
                      />
                    <cx-form-errors [control]="registerForm.get('firstName')" ></cx-form-errors>
                  </label>
                </div>
              }
              <div [class]="showProfessionalForm ? 'd-block' : 'd-md-flex justify-content-md-between'">
                <div class="form-group w-100 mr-sm-3">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.emailAddress.label' | cxTranslate }}
                    </span>
                    <input
                      class="form-control"
                      type="email"
                      name="email"
                      formControlName="email"
                      />
                    <cx-form-errors [control]="registerForm.get('email')" ></cx-form-errors>
                  </label>
                </div>
                <div class="form-group w-100">
                  <label class="label-password">
                    <span class="label-content mandatory">
                      {{ 'register.password.label' | cxTranslate }}
                    </span>
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      class="form-control"
                      formControlName="password"
                      />
                    <app-custom-icons (click)="isPasswordHidden()" [type]="showPassword ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
                    <cx-form-errors [control]="registerForm.get('password')"></cx-form-errors>
                  </label>
                </div>
              </div>
            </div>
            @if (showProfessionalForm) {
              <div class="col-md-6 input-field">
                <div class="title-register">
                  {{ 'register.companyInfo' | cxTranslate }}
                </div>
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.firstName.label' | cxTranslate }}
                    </span>
                    <input
                      class="form-control"
                      (focusin)="changeAetValidators(changeValidators)"
                      type="text"
                      name="firstName"
                      formControlName="firstName"
                      maxlength="70"
                      />
                    <cx-form-errors [control]="registerForm.get('firstName')" ></cx-form-errors>
                  </label>
                </div>
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.dni' | cxTranslate }}
                    </span>
                    <input
                      class="form-control" (focusin)="changeAetValidators(changeValidators)"
                      type="text"
                      name="documentIdentifier"
                      formControlName="documentIdentifier"
                      />
                    <cx-form-errors [control]="registerForm.get('documentIdentifier')" ></cx-form-errors>
                  </label>
                </div>
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">
                      {{ 'register.jobType' | cxTranslate }}
                    </span>
                    <select id="select-jobtype-register" formControlName="jobType" class="form-control filter-select">
                      <option selected disabled [ngValue]="null">
                        {{ 'register.selectJobType' | cxTranslate }}
                      </option>
                      @for (jobType of jobTypes$ | async; track jobType) {
                        <option [value]="jobType.code">
                          {{ jobType.name }}
                        </option>
                      }
                    </select>
                    <!--                  <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                    <cx-form-errors [control]="registerForm.get('jobType')" ></cx-form-errors>
                  </label>
                </div>
              </div>
            }
          }
          @if (validateTaxIdentification && showProfessionalForm) {
            <div class="title-register title-register-second-step col-md-12">
              {{ 'register.companyContactDetails' | cxTranslate }}
            </div>
            <div class="col-md-6 input-field">
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{'register.line1.label' | cxTranslate}}
                  </span>
                  <input
                    class="form-control"
                    type="text"
                    name="line1"
                    maxlength="70"
                    placeholder="{{ 'register.line1.placeholder' | cxTranslate }}"
                    formControlName="line1"
                    />
                  <cx-form-errors [control]="registerForm.get('line1')" ></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{ 'register.town.label' | cxTranslate }}
                  </span>
                  <input
                    class="form-control"
                    type="text"
                    name="town"
                    maxlength="35"
                    placeholder="{{ 'register.town.placeholder' | cxTranslate }}"
                    formControlName="town"
                    />
                  <cx-form-errors [control]="registerForm.get('town')" ></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{ 'register.mobilePhone.label' | cxTranslate }}
                  </span>
                  <input
                    class="form-control"
                    type="text"
                    name="mobilePhone"
                    placeholder="{{ 'register.mobilePhone.placeholder' | cxTranslate }}"
                    formControlName="mobilePhone"
                    />
                  <cx-form-errors [control]="registerForm.get('mobilePhone')" ></cx-form-errors>
                </label>
              </div>
            </div>
            <div class="col-md-6 input-field">
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{ 'register.postalCode.label' | cxTranslate }}
                  </span>
                  <input
                    class="form-control"
                    type="text"
                    name="postalCode" (keypress)="validatePostalCode()" (focusout)="validatePostalCode()"
                    placeholder="{{'register.postalCode.placeholder' | cxTranslate}}"
                    formControlName="postalCode"
                    />
                  <cx-form-errors [control]="registerForm.get('postalCode')" ></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{ 'register.region' | cxTranslate }}
                  </span>
                  <select id="selectRegionRegister" formControlName="regionCode" class="form-control filter-select">
                    <option selected disabled [ngValue]="null">
                      {{ 'register.selectRegion' | cxTranslate }}
                    </option>
                    @for (region of regions$ | async; track region) {
                      <option [value]="region.isocode">
                        {{ region.name }}
                      </option>
                    }
                  </select>
                  <!--                <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                  <cx-form-errors [control]="registerForm.get('regionCode')" ></cx-form-errors>
                </label>
              </div>
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">
                    {{ 'register.userTaxGroup.label' | cxTranslate }}
                  </span>
                  <select formControlName="userTaxGroup" class="form-control filter-select">
                    <option selected disabled [ngValue]="null">
                      {{ 'register.selectUserTaxGroup' | cxTranslate }}
                    </option>
                    @for (userTaxGroup of userTaxGroups$ | async; track userTaxGroup) {
                      <option [value]="userTaxGroup.code" >
                        {{ userTaxGroup.name }}
                      </option>
                    }
                  </select>
                  <!--                <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                  <cx-form-errors [control]="registerForm.get('userTaxGroup')" ></cx-form-errors>
                </label>
              </div>
            </div>
          }
          @if (validateTaxIdentification || !showProfessionalForm) {
            <div class="justify-content-center consents-container">
              <div class="consents">
                <div class="checkboxes">
                  <div class="form-group">
                    <div class="form-check">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          name="newsletter"
                          formControlName="newsletter"
                          />
                        <span class="form-check-label">
                          {{ 'register.newsletter' | cxTranslate }}
                        </span>
                        <cx-form-errors [control]="registerForm.get('newsletter')" ></cx-form-errors>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-check">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          name="termsAndConditions"
                          formControlName="termsAndConditions"
                          />
                        <span class="form-check-label">
                          {{ 'register.confirmThatRead' | cxTranslate }}
                        </span>
                        <cx-form-errors [control]="registerForm.get('termsAndConditions')" ></cx-form-errors>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="bottom-section">
                  <div class="button register-button">
                    <button type="submit" class="btn btn-black">
                      {{ 'register.registerButton' | cxTranslate }}
                    </button>
                  </div>
                </div>
                <div class="legal-text">
                  <span [innerHTML]="'register.legalText' | cxTranslate"></span>
                  <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                    {{ 'register.legalText2' | cxTranslate }}
                  </a>
                </div>
              </div>
            </div>
          }
          @if (showProfessionalForm) {
            <div class="bottom-section w-100">
              <div class="register-steps">
                @if (validateTaxIdentification) {
                  <div class="icon" (click)="goBackToSecondStep()">
                    <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
                  </div>
                  <div class="text">
                    {{ 'register.secondStep' | cxTranslate }}
                  </div>
                } @else {
                  <div class="text">
                    {{ 'register.firstStep' | cxTranslate }}
                  </div>
                }
              </div>
              <div class="button register-button">
                @if (!validateTaxIdentification) {
                  <button id="validate" type="button" class="btn btn-block btn-black" (click)="isValidateTaxIdentification()">
                    {{ 'register.validateRegister' | cxTranslate }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
} @else {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}

